<div class="field">
    <span class="field-title">Pesificación</span>
    
    <div class="inputs">
        <app-start-pesification class="input" [fieldIdentificator]="fieldIdentificator"></app-start-pesification>
        <app-end-pesification class="input"   [fieldIdentificator]="fieldIdentificator"></app-end-pesification>
    </div>
</div>